module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAG1BMVEUAAABVrO5VrO5VrO5VrO5VrO5VrO5VrO5VrO62E5ZzAAAACXRSTlMAQAAQv/+fz6/p+UjWAAAAv0lEQVR4Ae3UsW2EQBQE0LkWkFzAwekKuMS5JQpw8HFOCxYVuHFnDvYhkDY1E49eAPsn5sqV3IaxTcYm07ycl96r1rPStFVBRUgqQlIRkoqQVISkIiQVIakISUVIKkJSEZKKkFSEpCIkFSGpv9JcZGlLzyqzNqW3KvPZU3pUmY+mNG1Fvl5+AvJ98DGB/C1C/mAgn8o+5KMT8vkCeQhAxyf103+cnnn/YDg9/SPmHPYPqxPdP/bjfdgpmf9Wukq/Cd578evKOzUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f539.png
// module id = 1132
// module chunks = 0